export default __webpack_public_path__ + "static/media/vision.220c5ea6.jpg";